<!-- eslint-disable vue/multi-word-component-names -- Existing component, kept for backward compatibility -->
<template>
    <template v-if="isFooter">
        <div aria-hidden="true" :class="[propsClass]" class="bubble bubble-footer-left" />
        <div aria-hidden="true" :class="[propsClass]" class="bubble bubble-footer-center" />
        <div aria-hidden="true" :class="[propsClass]" class="bubble bubble-footer-right" />
    </template>
    <template v-else>
        <div aria-hidden="true" :class="[propsClass, positioning]" class="bubble bubble--left"></div>
        <div aria-hidden="true" :class="[propsClass, positioning]" class="bubble bubble--right"></div>
    </template>
</template>

<script setup>
import { computed } from "vue";
const props = defineProps({
    class: { type: String, default: "" },
    isFooter: { type: Boolean, default: false },
    direction: { type: String, default: "bottom" },
    directionMd: { type: String, default: "" },
});

const propsClass = computed(() => props.class);

const positioning = computed(() => {
    const classNames = [];
    switch (props.direction) {
        case "top":
            classNames.push("-translate-y-1/3", "top-auto", "bottom-0");
            break;

        case "left":
            classNames.push("-translate-x-1/3", "left-auto", "right-0");
            break;

        default:
        case "bottom":
            classNames.push("translate-y-1/3", "bottom-auto", "top-0");
            break;
    }

    if (props.directionMd) {
        switch (props.directionMd) {
            case "top":
                classNames.push("md:-translate-y-1/3", "md:top-auto", "md:bottom-0");
                break;

            default:
            case "bottom":
                classNames.push("md:translate-y-1/3", "md:bottom-auto", "bottom-0");
        }
    }

    return classNames.join(" ");
});
</script>

<style scoped>
@reference "../../../css/tailwind.css";
.bubble {
    @apply fixed overflow-hidden h-screen w-screen rounded-full scale-150 -z-10;
}

.bubble--right {
    @apply translate-x-1/3;
    background: radial-gradient(50% 50% at 50% 50%, rgba(0, 63, 220, 0.12) 0%, rgba(0, 63, 220, 0) 100%);
}

.bubble--left {
    @apply -translate-x-1/3;
    background: radial-gradient(50% 50% at 50% 50%, rgba(254, 40, 144, 0.12) 0%, rgba(254, 40, 144, 0) 100%);
}

.bubble-footer-left {
    @apply -translate-x-[20%] scale-75 translate-y-[55%];
    background: radial-gradient(50% 50% at 50% 50%, rgba(255, 197, 61, 0.5) 0%, rgba(255, 197, 61, 0) 100%);
}

.bubble-footer-center {
    @apply scale-75 translate-y-[55%];
    background: radial-gradient(50% 50% at 50% 50%, rgba(254, 40, 144, 0.24) 0%, rgba(254, 40, 144, 0) 100%);
}

.bubble-footer-right {
    @apply translate-x-[20%] scale-75 translate-y-[55%];
    background: radial-gradient(50% 50% at 50% 50%, rgba(169, 32, 203, 0.24) 0%, rgba(169, 32, 203, 0) 100%);
}
</style>
